import React, { useMemo } from 'react';
import { RSButtonLink } from '../../../reservation-page/RSButtonLink';
import KantanIcon from '../../../reservation-page/icons/kantan-icon.svg';
import { useUserMe } from '../../../hooks/api/me';
import { RSKantanIconButtonAnchor } from '../../../reservation-page/RSKantanIconButtonAnchor';
import { useRouter } from 'next/router';

type Props = {
  merchant_public_id: string;
  resource_public_id: string;
  isRequireCustomerLogin: boolean;
};

const MerchantStickyFooter = ({
  merchant_public_id,
  resource_public_id,
  isRequireCustomerLogin,
}: Props) => {
  const { user } = useUserMe();
  const router = useRouter();

  const M3ReservationFlowQuery = useMemo(() => {
    const query = new URLSearchParams();
    router.query.selected_slot &&
      query.set('timeSlotId', router.query.selected_slot as string);
    return query.toString();
  }, [router.query.selected_slot]);

  return (
    <div className="sticky bottom-0 block  border-0 border-t border-solid border-gray-50 bg-white px-[20px] py-2 legacyPc:hidden">
      {user ? (
        <RSButtonLink
          isBlock={true}
          href={`/${merchant_public_id}/${resource_public_id}/book/event_type`}
        >
          予約
        </RSButtonLink>
      ) : (
        <div className="flex flex-col gap-1.5">
          {!isRequireCustomerLogin && (
            <RSButtonLink
              isBlock={true}
              href={`/${merchant_public_id}/${resource_public_id}/book/event_type?${M3ReservationFlowQuery}`}
            >
              ゲスト予約
            </RSButtonLink>
          )}
          <RSKantanIconButtonAnchor
            icon={<KantanIcon width="24" height="24" viewBox="0 0 24 24" />}
            isBlock={true}
            href={`/signin/user?return_to=/${merchant_public_id}/${resource_public_id}/book/event_type?${M3ReservationFlowQuery}`}
            variant="black"
          >
            ログインして予約
          </RSKantanIconButtonAnchor>
        </div>
      )}
    </div>
  );
};

export default MerchantStickyFooter;
